// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-padding {
  padding: 0 !important;
}

.left-col {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

.right-col {
  padding-right: 0 !important;
  padding-left: 5px !important;
}

.fab {
  margin: 5px 0;
}
.fab ion-fab-button {
  width: 100%;
  height: 100%;
}
.fab ion-icon {
  width: 50%;
  height: 50%;
}

.vehicle-info-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}

.vehicle-info-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 5px;
}

.vehicle-info-row {
  width: 100%;
  height: 30%;
}

.vehicle-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  aspect-ratio: 1/1;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.vehicle-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.actions-fab-col {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
}

.info-row {
  width: 100%;
}

.info-col-left {
  padding: 0 5px 0 0;
  height: 100%;
}

.info-col-right {
  padding: 0 0 0 5px;
  height: 100%;
}

.vehicle-details-card {
  display: flex;
  flex-direction: row;
  padding: 5px;
  border-radius: 5px;
  height: 100%;
  width: 100%;
  margin: 0;
}

.vehicle-details-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.vehicle-details-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.vehicle-details-icon {
  width: var(--icon-size-large);
  height: var(--icon-size-large);
}

.vehicle-details-text-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.sessions-row {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.associated-pilots-col {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.associated-pilots-card {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.associated-pilots-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 12%;
  padding: 5px;
}

.associated-pilots-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.associated-pilots-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
}

.associated-pilots-card-content {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  padding: 5px;
  gap: 10px;
  min-height: 0;
  justify-content: center;
}

.session-item-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 0;
  padding: 5px 10px;
  align-items: center;
  width: 100%;
}

.session-info-col {
  display: flex;
  flex-direction: column;
  margin-left: 1vw;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.session-info-col ion-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

.droneIcon {
  width: var(--icon-size-large);
  height: var(--icon-size-large);
  flex: 0 0 auto;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  .fab {
    width: 25px;
    height: 25px;
  }
  .card-icon {
    font-size: 20px;
  }
  .info-text {
    font-size: var(--font-size-small);
  }
  .info-text-medium {
    font-size: var(--font-size-small) !important;
  }
  .info-text-small {
    font-size: var(--font-size-xx-small) !important;
  }
  .info-row {
    height: 25%;
  }
  .info-row-summary {
    height: 35%;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  .fab {
    width: 35px;
    height: 35px;
  }
  .card-icon {
    font-size: 25px;
  }
  .info-text {
    font-size: var(--font-size-small);
  }
  .info-text-medium {
    font-size: var(--font-size-small) !important;
  }
  .info-text-small {
    font-size: var(--font-size-xx-small) !important;
  }
  .info-row {
    height: 25%;
  }
  .info-row-summary {
    height: 35%;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  .fab {
    width: 45px;
    height: 45px;
  }
  .card-icon {
    font-size: 35px;
  }
  .info-text {
    font-size: var(--font-size-medium);
  }
  .info-text-medium {
    font-size: var(--font-size-medium) !important;
  }
  .info-text-small {
    font-size: var(--font-size-small) !important;
  }
  .info-row {
    height: 20%;
  }
  .info-row-summary {
    height: 30%;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/fleet/components/vehicle-info-card/vehicle-info-card.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,2BAAA;EACA,4BAAA;AACF;;AAEA;EAEE,aAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,UAAA;EACA,WAAA;AADJ;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;AAFF;;AAKA;EACE,WAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,6BAAA;EACA,8BAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,OAAA;EACA,aAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,WAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AAFF;AAIE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAFJ;;AAMA;EACE,6BAAA;EACA,8BAAA;EAEA,cAAA;AAJF;;AAQA,sEAAA;AAEE,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAPN;EAUI;IACE,eAAA;EARN;EAWI;IACE,iCAAA;EATN;EAYI;IACE,4CAAA;EAVN;EAaI;IACE,+CAAA;EAXN;EAcI;IACE,WAAA;EAZN;EAeI;IACE,WAAA;EAbN;AACF;AAgBE,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAhBN;EAmBI;IACE,eAAA;EAjBN;EAoBI;IACE,iCAAA;EAlBN;EAqBI;IACE,4CAAA;EAnBN;EAsBI;IACE,+CAAA;EApBN;EAuBI;IACE,WAAA;EArBN;EAwBI;IACE,WAAA;EAtBN;AACF;AAyBE,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAzBN;EA4BI;IACE,eAAA;EA1BN;EA6BI;IACE,kCAAA;EA3BN;EA8BI;IACE,6CAAA;EA5BN;EA+BI;IACE,4CAAA;EA7BN;EAgCI;IACE,WAAA;EA9BN;EAiCI;IACE,WAAA;EA/BN;AACF;AAkCE,4BAAA","sourcesContent":[".no-padding {\r\n  padding: 0 !important;\r\n}\r\n\r\n.left-col {\r\n  padding-left: 0 !important;\r\n  padding-right: 5px !important;\r\n}\r\n\r\n.right-col {\r\n  padding-right: 0 !important;\r\n  padding-left: 5px !important;\r\n}\r\n\r\n.fab {\r\n\r\n  margin: 5px 0;\r\n\r\n  ion-fab-button {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  ion-icon {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.vehicle-info-card{\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.vehicle-info-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 10px;\r\n  gap: 5px;\r\n}\r\n\r\n.vehicle-info-row {\r\n  width: 100%;\r\n  height: 30%;\r\n}\r\n\r\n.vehicle-avatar {\r\n  width: min(100%, 100%);\r\n  height: min(100%, 100%);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative;\r\n  aspect-ratio: 1/1;\r\n}\r\n\r\n.avatar-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.vehicle-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.actions-fab-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: right;\r\n}\r\n\r\n.info-row {\r\n  width: 100%;\r\n}\r\n\r\n.info-col-left {\r\n  padding: 0 5px 0 0;\r\n  height: 100%;\r\n}\r\n\r\n.info-col-right {\r\n  padding: 0 0 0 5px;\r\n  height: 100%;\r\n}\r\n\r\n.vehicle-details-card {\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n  height: 100%;\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.vehicle-details-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.vehicle-details-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: left;\r\n}\r\n\r\n.vehicle-details-icon {\r\n  width: var(--icon-size-large);\r\n  height: var(--icon-size-large);\r\n}\r\n\r\n.vehicle-details-text-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: left;\r\n}\r\n\r\n.sessions-row {\r\n  flex: 1;\r\n  min-height: 0;\r\n  width: 100%;\r\n}\r\n\r\n.associated-pilots-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n}\r\n\r\n.associated-pilots-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.associated-pilots-card-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: 12%;\r\n  padding: 5px;\r\n}\r\n\r\n.associated-pilots-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.associated-pilots-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.associated-pilots-card-content {\r\n  width: 100%;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n  gap: 10px;\r\n  min-height: 0;\r\n  justify-content: center;\r\n}\r\n\r\n.session-item-row {\r\n  display:flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n  padding: 5px 10px;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.session-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 1vw;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n\r\n  ion-label {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.droneIcon {\r\n  width: var(--icon-size-large);\r\n  height: var(--icon-size-large);\r\n\r\n  flex: 0 0 auto;\r\n}\r\n\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n  /*#region Small Screens*/\r\n\r\n    /* Styles for screens smaller than 800px wide or 550 high */\r\n    @media (max-width: 599px) {\r\n      .fab {\r\n        width: 25px;\r\n        height: 25px;\r\n      }\r\n\r\n      .card-icon {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .info-text {\r\n        font-size: var(--font-size-small);\r\n      }\r\n\r\n      .info-text-medium {\r\n        font-size: var(--font-size-small) !important;\r\n      }\r\n\r\n      .info-text-small {\r\n        font-size: var(--font-size-xx-small) !important;\r\n      }\r\n\r\n      .info-row {\r\n        height: 25%;\r\n      }\r\n\r\n      .info-row-summary {\r\n        height: 35%;\r\n      }\r\n    }\r\n\r\n  /*#endregion Small Screens*/\r\n\r\n  /*#region Medium Screens*/\r\n\r\n    /* Styles for medium screens with min with of 800px and min height of 550px */\r\n    @media (min-width: 600px) and (max-width: 1023px) {\r\n      .fab {\r\n        width: 35px;\r\n        height: 35px;\r\n      }\r\n\r\n      .card-icon {\r\n        font-size: 25px;\r\n      }\r\n\r\n      .info-text {\r\n        font-size: var(--font-size-small);\r\n      }\r\n\r\n      .info-text-medium {\r\n        font-size: var(--font-size-small) !important;\r\n      }\r\n\r\n      .info-text-small {\r\n        font-size: var(--font-size-xx-small) !important;\r\n      }\r\n\r\n      .info-row {\r\n        height: 25%;\r\n      }\r\n\r\n      .info-row-summary {\r\n        height: 35%;\r\n      }\r\n    }\r\n\r\n  /*#endregion Medium Screens*/\r\n\r\n  /*#region Larger Screens*/\r\n\r\n    /* Styles for screens larger than 1000px wide and 600px high */\r\n    @media (min-width: 1024px) {\r\n      .fab {\r\n        width: 45px;\r\n        height: 45px;\r\n      }\r\n\r\n      .card-icon {\r\n        font-size: 35px;\r\n      }\r\n\r\n      .info-text {\r\n        font-size: var(--font-size-medium);\r\n      }\r\n\r\n      .info-text-medium {\r\n        font-size: var(--font-size-medium) !important;\r\n      }\r\n\r\n      .info-text-small {\r\n        font-size: var(--font-size-small) !important;\r\n      }\r\n\r\n      .info-row {\r\n        height: 20%;\r\n      }\r\n\r\n      .info-row-summary {\r\n        height: 30%;\r\n      }\r\n    }\r\n\r\n  /*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
